import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert } from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useTechnicianAuth } from '../../contexts/TechnicianAuthContext';

/** Cambio obligatorio del PIN temporal en el primer acceso. */
export default function ChangePin() {
  const { changePin, logout } = useTechnicianAuth();
  const [currentPin, setCurrentPin] = useState('');
  const [newPin, setNewPin] = useState('');
  const [repeatPin, setRepeatPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPin !== repeatPin) {
      setError('Los PIN nuevos no coinciden');
      return;
    }
    if (!/^\d{6,}$/.test(newPin)) {
      setError('El PIN debe tener al menos 6 digitos');
      return;
    }
    setLoading(true);
    try {
      await changePin(currentPin, newPin);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se ha podido cambiar el PIN');
    } finally {
      setLoading(false);
    }
  };

  const pinField = (label, value, setter, autoFocus) => (
    <TextField
      fullWidth label={label} value={value} required sx={{ mb: 2 }}
      autoFocus={autoFocus}
      onChange={(e) => setter(e.target.value.replace(/\D/g, ''))}
      inputProps={{ inputMode: 'numeric', maxLength: 12,
                    style: { fontSize: 22, letterSpacing: 4, textAlign: 'center' } }}
      type="password"
    />
  );

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', backgroundColor: '#ffebee', p: 2,
    }}>
      <Paper sx={{ p: 3, maxWidth: 380, width: '100%' }} elevation={3}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <LockResetIcon color="primary" sx={{ fontSize: 44 }} />
          <Typography variant="h6" fontWeight="bold">Cambia tu PIN</Typography>
          <Typography variant="body2" color="textSecondary">
            Por seguridad, elige un PIN nuevo que solo conozcas tu.
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          {pinField('PIN actual', currentPin, setCurrentPin, true)}
          {pinField('PIN nuevo', newPin, setNewPin, false)}
          {pinField('Repite el PIN nuevo', repeatPin, setRepeatPin, false)}
          <Button fullWidth variant="contained" size="large" type="submit"
            disabled={loading} sx={{ height: 52, fontSize: 17 }}>
            {loading ? 'Guardando...' : 'Guardar PIN'}
          </Button>
        </form>

        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button size="small" onClick={logout} sx={{ textTransform: 'none' }}>
            Salir
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
